/**
 * Подписка на новости и акции.
 *
 * Стоит в конце ленты, где раньше была пустота между брендами и подвалом.
 * Место удачное по смыслу: человек долистал до низа, значит он посмотрел всё,
 * что идёт сейчас, и единственное, что мы можем ему предложить дальше, —
 * сказать, когда появится новое.
 *
 * Подписка не требует аккаунта: это разные обещания, и смешивать их нельзя.
 * Вошедшему адрес подставляется, но отправляет он его всё равно сам.
 */
import { ApiError } from '@allswipes/client';
import { Button } from '@allswipes/ui';
import { useRef, useState } from 'react';

import { api } from '../api';
import { useT } from '@allswipes/i18n';
import { useSession } from '../session';
import { useToast } from '../toast';

export function Subscribe() {
  const t = useT();
  const { profile } = useSession();
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const input = useRef<HTMLInputElement>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const value = email.trim() || profile?.user.login || '';
    if (!value) {
      input.current?.focus();
      return;
    }
    setBusy(true);
    try {
      await api.subscribe(value, profile?.user.region, 'feed');
      setDone(true);
    } catch (err) {
      toast(err instanceof ApiError ? err.message : t('Не получилось подписаться'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="subs">
      <div className="subs-text">
        <span className="subs-eye">{t('Новости и акции')}</span>

        {done ? (
          <>
            <h2 className="subs-title">{t('Готово')}</h2>
            <p className="subs-note">
              {t(
                t('Адрес в списке. Первое письмо придёт, когда появится что-то стоящее: новые акции, итоги розыгрышей, важное по платформе. Отписаться можно одной ссылкой в любом из них.'),
              )}
            </p>
          </>
        ) : (
          <>
            <h2 className="subs-title">{t('Узнавай об акциях первым')}</h2>
            <p className="subs-note">
              {t(
                t('Пишем редко и по делу: что стартовало в твоей стране, где розыгрыш на этой неделе и чем он закончился. Без рекламы ради рекламы — её хватает и без нас.'),
              )}
            </p>

            <form className="subs-form" onSubmit={submit}>
              <input
                ref={input}
                type="email"
                inputMode="email"
                autoComplete="email"
                placeholder={profile?.user.login || t('почта')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-label={t('Почта для новостей')}
              />
              <Button variant="pri" type="submit" disabled={busy}>
                {busy ? t('Минуту…') : t('Подписаться')}
              </Button>
            </form>

            <p className="subs-fine">
              {t(
                t('Адрес нужен только для писем об акциях. Брендам он не передаётся — им вообще не видно, кто на что подписан.'),
              )}
            </p>
          </>
        )}
      </div>

      {/* Иллюстрация decorative: без неё блок читается так же, поэтому у неё
          пустой alt и она не уезжает в поток чтения с экрана. */}
      <img className="subs-art" src="/subscribe.webp" alt="" loading="lazy" width={900} height={672} />
    </section>
  );
}
